import { render, staticRenderFns } from "./ProductGroupTableRow.vue?vue&type=template&id=374f07d6&"
import script from "./ProductGroupTableRow.vue?vue&type=script&lang=js&"
export * from "./ProductGroupTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports